export default __webpack_public_path__ + "static/B0299-89573775ec391872c9897c6cd9ccdc10.png";